module.exports = __webpack_public_path__ + "static/image@2x-f7a2334130970974309d75e49a3d38a8.png";